import { Reducer } from 'redux';
import {
  ClassifierState,
  GET_CLASSIFIER_LIST,
  ClassifierActionTypes,
  GET_CLASSIFIER,
  POST_CLASSIFIER,
  PUT_CLASSIFIER,
  DELETE_CLASSIFIER
} from '../types/classifier.types';

const initialState: ClassifierState = {
  classifiers: [],
  selectedClassifier: null,
  postSuccess: null,
  lastFetch: null,
  totalElements: 0,
  totalPages: 1
};

export const classifierReducer: Reducer<ClassifierState> = (
  state: ClassifierState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as ClassifierActionTypes).type) {
    case GET_CLASSIFIER_LIST:
      return {
        classifiers: action.payload.page.content,
        selectedClassifier: null,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalElements: action.payload.page.totalElements,
        totalPages: action.payload.page.totalPages
      };
    case GET_CLASSIFIER:
      return {
        ...state,
        postSuccess: null,
        selectedClassifier: action.payload.selectedClassifier,
        lastFetch: timeOfAction
      };
    case POST_CLASSIFIER:
      return {
        ...state,
        postSuccess: true,
        selectedClassifier: action.payload.newClassifier,
        lastFetch: timeOfAction
      };
    case PUT_CLASSIFIER:
      return {
        ...state,
        selectedClassifier: action.payload.selectedClassifier,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_CLASSIFIER:
      return {
        ...state,
        selectedClassifier: null,
        lastFetch: timeOfAction
      };
    default:

      return state;
  }
};
